var getSetpayDataSections = function (accountSummaryData, autopayStatusData, t) {
    var installment = accountSummaryData.installment, credit = accountSummaryData.credit, billing = accountSummaryData.billing;
    return {
        dataSections: [
            {
                heading: t("grid.titles.loanSummary"),
                sectionName: "loan-summary",
                dataElements: [
                    {
                        value: installment === null || installment === void 0 ? void 0 : installment.principalAmount,
                        label: t("grid.labels.loanAmount"),
                        type: "amount",
                    },
                    {
                        value: installment === null || installment === void 0 ? void 0 : installment.interestRate,
                        label: t("grid.labels.interestRate"),
                        type: "percentage",
                    },
                    {
                        value: installment === null || installment === void 0 ? void 0 : installment.startDate,
                        label: t("grid.labels.loanStartDate"),
                        type: "date",
                    },
                    {
                        value: installment === null || installment === void 0 ? void 0 : installment.loanTerm,
                        label: t("grid.labels.loanTerm"),
                        type: "months",
                    },
                ],
            },
            {
                heading: t("grid.titles.payments"),
                sectionName: "payments",
                dataElements: [
                    {
                        value: billing === null || billing === void 0 ? void 0 : billing.nextPaymentDate,
                        label: t("grid.labels.nextPaymentDate"),
                        type: "date",
                    },
                    {
                        value: billing === null || billing === void 0 ? void 0 : billing.totalMinimumPaymentDue,
                        label: t("grid.labels.nextAmountDue"),
                        type: "amount",
                        toolTipText: t("grid.labels.nextAmountMothlyTooltip"),
                    },
                    {
                        value: billing.lastPaymentDate,
                        label: t("grid.labels.lastPaymentDate"),
                        type: "date",
                    },
                    {
                        value: billing === null || billing === void 0 ? void 0 : billing.lastPaymentAmount,
                        label: t("grid.labels.lastPaymentAmount"),
                        type: "amount",
                    },
                    {
                        value: (autopayStatusData === null || autopayStatusData === void 0 ? void 0 : autopayStatusData.enrollment)
                            ? t("grid.labels.autoPayStatus.on")
                            : t("grid.labels.autoPayStatus.off"),
                        label: t("grid.labels.autoPayStatus.text"),
                        type: "text",
                    },
                ],
            },
            {
                heading: t("grid.titles.loanInformation"),
                sectionName: "loan-information",
                dataElements: [
                    {
                        value: credit === null || credit === void 0 ? void 0 : credit.currentBalance,
                        label: t("grid.labels.estimatedPayoffAmount"),
                        type: "amount",
                        toolTipText: t("grid.labels.estimatedPayoffAmountTooltip"),
                    },
                    {
                        value: installment === null || installment === void 0 ? void 0 : installment.monthlyAmountDue,
                        label: t("grid.labels.monthlyLoanPayment"),
                        type: "amount",
                    },
                    {
                        value: installment === null || installment === void 0 ? void 0 : installment.termRemaining,
                        label: t("grid.labels.termRemaining"),
                        type: "months",
                    },
                    {
                        value: installment === null || installment === void 0 ? void 0 : installment.endDate,
                        label: t("grid.labels.loanEndDate"),
                        type: "date",
                    },
                ],
            },
        ],
    };
};
export default getSetpayDataSections;
//# sourceMappingURL=getSetpayDataSections.js.map